import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { connect } from 'react-redux'
import { push } from 'react-router-redux'

import { isEmpty } from 'lodash'

import * as selectors from './selectors'

import * as recentActions from 'Global/Stores/recent'
import * as previewModalActions from 'Global/Stores/previewModalMain'
import { getStatistics } from 'Global/Stores/statistics'
import { hasTrueValues } from 'Global/Helpers/objectHelpers'
import { isRole } from 'Global/Helpers/userHelpers'
import { previewModalCurrentIndexSet } from 'Global/Stores/previewModal'

export default function(WrappedComponent) {
  class Enhancer extends Component {
    static displayName = 'MainModuleEnhancer'

    static propTypes = {
      currentIndex: PropTypes.number.isRequired,
      currentPicture: PropTypes.string.isRequired,
      currentRug: PropTypes.object.isRequired,
      errors: PropTypes.object.isRequired,
      getRecent: PropTypes.func.isRequired,
      getRecentMarkedForDesigners: PropTypes.func.isRequired,
      getRecentOrders: PropTypes.func.isRequired,
      getStatistics: PropTypes.func.isRequired,
      nextPicture: PropTypes.bool.isRequired,
      pendings: PropTypes.object.isRequired,
      previewExpanded: PropTypes.bool.isRequired,
      previewOpen: PropTypes.bool.isRequired,
      previousPicture: PropTypes.bool.isRequired,
      recent: PropTypes.array.isRequired,
      recentMarkedForDesigners: PropTypes.array.isRequired,
      recentOrders: PropTypes.array.isRequired,
      setCurrentIndex: PropTypes.func.isRequired,
      statistics: PropTypes.object.isRequired,
      togglePreview: PropTypes.func.isRequired,
      togglePreviewExpansion: PropTypes.func.isRequired,
      user: PropTypes.object.isRequired,
    }

    componentDidMount() {
      const {
        getRecent,
        getRecentMarkedForDesigners,
        getRecentOrders,
        getStatistics,
        recent,
        recentMarkedForDesigners,
        recentOrders,
        statistics,
        user,
      } = this.props

      if (isEmpty(recentOrders) && (isRole(user, 'advisor') && !isRole(user, 'designer'))) {
        const advisor = `${user.firstName} ${user.lastName}`

        getRecentOrders(advisor, user.additionalAdvisors)
      }

      if (isEmpty(recentMarkedForDesigners) && isRole(user, 'designer')) {
        getRecentMarkedForDesigners()
      }

      if (isEmpty(recent)) {
        getRecent()
      }

      if (isEmpty(statistics)) {
        getStatistics()
      }
    }

    render() {
      const { errors, pendings, recent, recentMarkedForDesigners, recentOrders, statistics } = this.props

      return (
        <WrappedComponent
          hasError={hasTrueValues(errors)}
          loaderPending={!hasTrueValues(errors) && hasTrueValues(pendings)}
          recent={recent}
          recentMarkedForDesigners={recentMarkedForDesigners}
          recentOrders={recentOrders}
          statistics={statistics}
          {...this.props}
        />
      )
    }
  }

  const mapStateToProps = (state, ownProps) => ({
    currentIndex: selectors.currentIndex(state),
    currentPicture: selectors.currentPicture(state),
    currentRug: selectors.currentRug(state),
    errors: selectors.errors(state),
    nextPicture: selectors.nextPicture(state),
    pendings: selectors.pendings(state),
    previewExpanded: selectors.previewExpanded(state),
    previewOpen: selectors.previewOpen(state),
    previousPicture: selectors.previousPicture(state),
    recent: selectors.recent(state),
    recentMarkedForDesigners: selectors.recentMarkedForDesigners(state),
    recentOrders: selectors.recentOrders(state),
    statistics: selectors.statistics(state),
    user: selectors.user(state),
  })

  const mapDispatchToProps = (dispatch, ownProps) => ({
    getRecent: () => dispatch(recentActions.getRecent()),
    getRecentMarkedForDesigners: () => dispatch(recentActions.getRecentMarkedForDesigners()),
    getRecentOrders: (advisor, additionalAdvisors) => dispatch(recentActions.getRecentOrders(advisor, additionalAdvisors)),
    getStatistics: () => dispatch(getStatistics()),
    redirectToSearch: user => dispatch(push('/search')),
    setCurrentIndex: index => dispatch(previewModalCurrentIndexSet(index)),
    togglePreview: rugType => dispatch(previewModalActions.togglePreview(rugType)),
    togglePreviewExpansion: () => dispatch(previewModalActions.toggleExpansion()),
  })

  return connect(
    mapStateToProps,
    mapDispatchToProps,
  )(Enhancer)
}
